/* eslint-disable func-names, max-len */
import fitvids from 'fitvids';
import 'fancybox-core';
import 'fancybox-media';
import 'onenav';
import 'jigowatt';
import 'jquery.scrollto';

$(() => {
  if (!$('.promo-page-section').length) {
    return;
  }

  require.ensure(['bootstrap/js/tab'], () => {
    require('bootstrap/js/tab');

    // .intro-section reduce opacity when scrolling down
    $(window).scroll(() => {
      if ($(window).width() > 1260) {
        const windowScroll = $(window).scrollTop();
        const contentOpacity =
          1 -
          windowScroll /
            ($('.promo-page-section:first').offset().top + $('.promo-page-section:first').height());

        const $intoSection = $('.intro-section:not(.js-ignore)');
        $intoSection.css('transform', `translateY(${Math.floor(windowScroll * 0.16)}px)`);
        $intoSection.css('-webkit-transform', `translateY(${Math.floor(windowScroll * 0.16)}px)`);
        $intoSection.css('opacity', contentOpacity.toFixed(2));
      }
    });

    // Get All Page Sections for navigation
    const $pageSections = $(".promo-page .promo-page-section:not([data-navigation=''])");

    // if a length then bind the custom menu
    if ($pageSections.length) {
      // Fixed navigation
      $(window).scroll(() => {
        const hasChildItems = $('.promo-page .sub-nav').children().length > 0;
        if (!hasChildItems) {
          return;
        }

        if ($(window).scrollTop() > 500) {
          $('.sub-navbar').addClass('fixednav');
          $('header').addClass('hide-main-nav');
        } else {
          $('.sub-navbar').removeClass('fixednav');
          $('header').removeClass('hide-main-nav');
        }
      });
    }

    // Dynamically generate the navigation based on the widgets placed on the page.
    const $navItems = $('.promo-page .sub-nav');
    $pageSections.each((i, v) => {
      const activeItem = i === 0 ? 'class="current"' : '';

      const itemName = $(v).data('navigation');

      if (itemName) {
        $navItems.append(`<li ${activeItem}><a href="#${$(v).attr('id')}">${itemName}</a></li>`);
      }
    });

    // Initiat onepageNav.js
    $('.sub-nav').onePageNav({
      currentClass: 'current',
      scrollOffset: 500,
    });

    // Hide Mobile Nav when clicking item
    $('.sub-nav a, .sub-navbar-header a').click(() => {
      $('.sub-navbar-collapse')
        .removeClass('in')
        .addClass('collapse');
    });

    $('.sub-navbar .sub-navbar-toggle').click(() => {
      $('.sub-navbar-collapse').toggleClass('collapse');
    });

    const $btnIntroOne = $('.js-btn-intro-one');
    if ($btnIntroOne.length) {
      const scrollToOne = $btnIntroOne.data('scrollto');

      $btnIntroOne.click(() => {
        $.scrollTo($(`*[data-navigation="${scrollToOne}"]`), 1000);
      });
    }

    const $btnIntroTwo = $('.js-btn-intro-two');
    if ($btnIntroTwo.length) {
      const scrollToTwo = $btnIntroTwo.data('scrollto');

      $btnIntroTwo.click(() => {
        $.scrollTo($(`*[data-navigation="${scrollToTwo}"]`), 1000);
      });
    }

    const $btnIntroThree = $('.js-btn-intro-three');
    if ($btnIntroThree.length) {
      const scrollToThree = $btnIntroThree.data('scrollto');

      $btnIntroThree.click(() => {
        $.scrollTo($(`*[data-navigation="${scrollToThree}"]`), 1000);
      });
    }
    /* Buttons Scroll to Div */
    $('.sub-navbar-brand').click(() => {
      $.scrollTo('.intro', 1000);
      return false;
    });

    $('.btn-video').unbind();

    $('[data-redirect]').click(function() {
      window.location.href = $(this).data('redirect');
      return false;
    });

    // Terms animation
    $('.view-terms-conditions-agree.primary').click(e => {
      e.preventDefault();
      const $termsText = $('.win-terms-text.primary');

      if (!$termsText.hasClass('open-terms')) {
        $termsText.addClass('open-terms');
        $termsText.addClass('subscription-lightbox-terms');
        $termsText.height($termsText.attr('data-height'));
      } else {
        $termsText.removeClass('open-terms');
      }
    });
    // Open Terms animation
    $('.view-terms-conditions-agree.secondary').click(e => {
      e.preventDefault();
      const $termsText = $('.win-terms-text.secondary');

      if (!$termsText.hasClass('open-terms')) {
        $termsText.addClass('open-terms');
        $termsText.addClass('subscription-lightbox-terms');
        $termsText.height($termsText.attr('data-height'));
      } else {
        $termsText.removeClass('open-terms');
        $termsText.removeClass('subscription-lightbox-terms');
      }
    });

    // Close on X
    $('.win-terms-text .close-terms').click(() => {
      const $termsText = $('.win-terms-text');

      if (!$termsText.hasClass('open-terms')) {
        $termsText.addClass('open-terms');
      } else {
        $termsText.removeClass('open-terms');
        $termsText.removeClass('subscription-lightbox-terms');
      }
    });

    // Close terms on esc
    $(document).keyup(e => {
      if (e.keyCode === 27) {
        const $termsText = $('.win-terms-text');

        if ($termsText.hasClass('open-terms')) {
          $termsText.removeClass('open-terms');
          $termsText.removeClass('subscription-lightbox-terms');
        }
      }
    });

    window.self.termsHeight = function() {
      const $termsPopup = $('.win-terms-text');
      if ($termsPopup.length > 0) {
        $termsPopup.prependTo('form');

        const $termsHeading = $termsPopup.find('h1, h2');
        const $termsText = $termsPopup.find('p');
        if ($termsHeading.length > 0 && $termsText.length > 0) {
          // $termsText.css('height', 'calc(100% - ' + $termsHeading.outerHeight() + 'px)');
        }
      }
    };

    // Screenshot carousel
    $('.screens').slick({
      arrows: true,
      dots: false,
      draggable: true,
      infinite: true,
      /* eslint-disable max-len */
      nextArrow: '<i class="fa fa-chevron-left btn-slide"></i>',
      prevArrow: '<i class="fa fa-chevron-right btn-slide"></i>',
      /* eslint-enable max-len */
      slidesToShow: 4,
      slidesToScroll: 1,
      swipe: true,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // Screenshot lightbox
    $('.screens a').fancybox();

    const $smallSliders = $('.small-slider');
    $smallSliders.each(function() {
      const $smallSlider = $(this);

      if ($smallSlider.find('.item').length > 1) {
        $smallSlider.slick({
          arrows: true,
          dots: false,
          draggable: true,
          infinite: true,
          /* eslint-disable max-len */
          nextArrow: '<i class="fa fa-chevron-left btn-slide"></i>',
          prevArrow: '<i class="fa fa-chevron-right btn-slide"></i>',
          /* eslint-enable max-len */
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        });
      }
    });

    // Add view more button if Features text is too long
    function initExcessBtn() {
      if ($(window).innerWidth() > 991) {
        $('.fetaure-details > p').each(function() {
          if ($(this).height() > 120) {
            $(this)
              .parent()
              .addClass('feature--hide-excess');
            initViewMore($(this).siblings('.feature__view-more'));
          }
        });
      } else {
        $('.fetaure-details').removeClass('feature--hide-excess, feature--show-excess');
      }
    }
    // Initiate View more button
    function initViewMore(button) {
      button.on('click', function() {
        if (
          !$(this)
            .parent()
            .hasClass('feature--show-excess')
        ) {
          $(this)
            .parent()
            .addClass('feature--show-excess');
          $(this).text('Hide');
        } else {
          $(this)
            .parent()
            .removeClass('feature--show-excess');
          $(this).text('View more');
        }
      });
    }

    // Initiat fitVids.js
    fitvids('.video-item');

    // Check if window width has changed
    $(window).resize(() => {
      initExcessBtn();
    });

    // Bootstrap Tab navigation
    $('.tabs a').click(e => {
      e.preventDefault();
      $(this).tab('show');
    });
    // Custom class toggling for bootstrap tabs as carousel caused issues with "active" class name
    $('.js-36v-tabs .tabs a').click(() => {
      $('.tabs ul li.active').removeClass('active');
      $(this)
        .parent('li')
        .addClass('active');
    });

    const nextHtml = `<a title="Next" class="fancybox-nav fancybox-next promo-popup-next">${$(
      '.js-translation-next',
    )
      .first()
      .text()}</a>`;
    const prevHtml = `<a title="Previous" class="fancybox-nav fancybox-prev promo-popup-prev">${$(
      '.js-translation-prev',
    )
      .first()
      .text()}</a>`;

    // init fancybox
    $('.promo-page-popup .fancybox').fancybox({
      loop: false,
      tpl: {
        next: nextHtml,
        prev: prevHtml,
      },
    });

    // ensure clicking on image causes the fancybox to open
    $('.promo-page-popup .init-fancybox').click(function() {
      $(this)
        .next()
        .children()
        .first()
        .trigger('click');
    });

    $('.promo-page-popup .content-overlay .read-more').click(function() {
      $(this)
        .parents('.promo-page-popup')
        .find('.init-fancybox')
        .trigger('click');
    });

    $('.promo-page-popup .promo-popup-viewproducts').click(function() {
      $.fancybox.close();
      if ($('.promo-page .products .tabs').length > 0) {
        $('html,body').animate(
          {
            scrollTop: $('.promo-page .products .tabs').offset().top - 90,
          },
          1000,
        );
      }

      const filter = $(this).data('listfilter');

      if (filter.length > 0) {
        const selector = `.promo-product-tabs select option[label="${filter}"]`;
        $('.promo-product-tabs select').val($(selector).val());
        $('.promo-product-tabs select')
          .chosen()
          .change();
        $('.promo-product-tabs select').trigger('liszt:updated');
      }
    });

    $('.promo-page-popup[data-scrollfilter]').click(function() {
      if ($('.promo-page .products .tabs').length > 0) {
        $('html,body').animate(
          {
            scrollTop: $('.promo-page .products .tabs').offset().top - 90,
          },
          1000,
        );
      }

      const filter = $(this).data('scrollfilter');

      if (filter.length > 0) {
        const selector = `.promo-product-tabs select option[label="${filter}"]`;
        $('.promo-product-tabs select').val($(selector).val());
        $('.promo-product-tabs select')
          .chosen()
          .change();
        $('.promo-product-tabs select').trigger('liszt:updated');
      }
    });

    $('.promo-page-popup[data-scrollfilter] .init-fancybox').click(function() {
      $(this)
        .parents('.promo-page-popup')
        .trigger('click');
    });
  });
});
